<template>
  <v-app>

    <raambanners-canvas></raambanners-canvas>

  </v-app>
</template>

<script>
import RaambannersCanvas from "@/components/RaambannersCanvas";

export default {
  name: 'App',
  components: {
    RaambannersCanvas,
  },
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
